module.exports = __webpack_public_path__ + "static/media/cross.1c26cef1.svg";